import { Modal } from "components";
import { useSearch } from "react-location";
import { LocationGenerics } from "router/location";
import { useTargetBadge } from "hooks/data/use-target-badge";
import TargetBadgeView from "components/cards/target-badge-view";

export default function ViewTargetBadgeContainer({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
}) {
  const searchParams = useSearch<LocationGenerics>();
  const { loading, badge } = useTargetBadge({
    badgeId: searchParams?.id || "",
  });

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      loading={loading}
      title="View Badge Details"
      description="Details of the target badge are shown below"
    >
      <TargetBadgeView badge={badge} />
    </Modal>
  );
}
